<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1000px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="success"
        block
        v-on="on"
      >
        Create Leave Type
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Leave Type"
      text="Create Leave Type"
      class="mb-0"
    > 
      <v-stepper
        :value="stepper"
        :vertical="false"
      >
        <v-stepper-header>
          <span
            v-for="(step,i) in steps"
            :key="i"
          >
            <v-stepper-step
              :step="i + 1"
              :complete="i+1<stepper"
            >
              {{ step.name }}
            </v-stepper-step>

            <v-divider />
          </span>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content
            :vertical="false"
            :step="1"
          >
            <setup-leaves-types-stepper-form-create
              v-if="dialog"
              ref="leaveTypePositionForm"
              :combined-leave-types="combinedLeaveTypes"
              @close-dialog="closeDialog"
              @next-step="nextStep"
            />
          </v-stepper-content>

          <v-stepper-content
            :vertical="false"
            :step="2"
          >
            <setup-leaves-types-stepper-approval-levels-form-create
              v-if="dialog"
              ref="leaveTypeLevelForm"
              class="elevation-3"
              @previous-step="previousStep"
              @next-step="nextStep"
            />
          </v-stepper-content>

          <v-stepper-content
            :vertical="false"
            :step="3"
          >
            <setup-leaves-types-stepper-approval-authorities-form-create
              v-if="dialog"
              ref="leaveTypeAuthorityForm"
              class="elevation-3"
              @previous-step="previousStep"
              @submit-form="submitForm"
            />
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    components: {
      SetupLeavesTypesStepperFormCreate: () => import('@/components/setup/leaves/types/StepperFormCreate'),
      SetupLeavesTypesStepperApprovalLevelsFormCreate: () => import('@/components/setup/leaves/types/StepperApprovalLevelsFormCreate'),
      SetupLeavesTypesStepperApprovalAuthoritiesFormCreate: () => import('@/components/setup/leaves/types/StepperApprovalAuthoritiesFormCreate'),
    },
    inject: ['$validator'],
    props: {
      combinedLeaveTypes: {
        type: Array,
        required: true,
      },
    },
    data () {
      return {
        steps: [
          { 'name': 'Create a Leave Type' },
          { 'name': 'Setup Approval Requirement' },
          { 'name': 'Setup Leave Authorization' },
        ],
        stepper: 1,
        dialog: false,        
        progressing: false,        
      }
    },
    watch: {
      dialog (value) {
        if (value) {
          this.stepper = 1
        }
      },
    },
    methods: {
      closeDialog () {
        this.dialog = false
      },
      nextStep () {
        this.stepper += 1
      },
      previousStep () {
        this.stepper -= 1
      },
      submitForm () {
        this.progressing = true
        let data = this.$refs.leaveTypePositionForm.getFormData()

        this.$api.leaveTypes().create(data)
          .then((res) => {
            if (res.status === 201) {              
              let leaveType = res.data
              this.createLevelAndAuthority(leaveType.id)  
            }
          })
          .catch((err) => {
            if (err.response.status === 422) {              
              this.stepper = 1
            }            
            this.progressing = false
          })
      },   
      createLevelAndAuthority (leaveTypeId) {        
        let levelData = this.$refs.leaveTypeLevelForm.getFormData()
        let authorityData = this.$refs.leaveTypeAuthorityForm.getFormData()

        this.$http.all([
          this.$api.leaveTypeApprovalLevels().update(leaveTypeId, levelData),
          this.$api.leaveTypeApprovalAuthorities().update(leaveTypeId, authorityData),
        ])
          .then(this.$http.spread((authority, level) => {
            if (authority.status === 200 && level.status === 200) {
              this.$emit('created')                
              this.$snack({ message: 'Successfully created leave type and authorities' })
            }
          }))
          .catch(() => {})
          .then(() => {
            this.progressing = false
            this.dialog = false
          })
      }, 
    },
  }
</script>
